export const Headers = {
  SessionToken: 'x-session-token',
  Authorization: 'Authorization',
  UserInfo: 'X-USERINFO',
};

export const RETRY_DELAY_MSEC = 1e3;
export const RETRY_ATTEMPS = 4;
export const StatusCode = {
  BAD: 400,
  SUCCESS: 200,
};
